import React from 'react';
import { Wrench } from 'lucide-react';
import type { DashboardProject } from '../../../../../types/project';
import { BuckleArrestorSection } from './BuckleArrestorSection';
import { PipeInPipeSection } from './PipeInPipeSection';
import { BulkHeadSection } from './BulkHeadSection';

interface FabricationTypeSectionProps {
  project: DashboardProject;
}

export const FabricationTypeSection: React.FC<FabricationTypeSectionProps> = ({ project }) => {
  if (!project.projectTypes.fabrication || !project.fabricationOptions) {
    console.log('No fabrication options found',project);
    return null;
  }

  return (
    <div className="space-y-6">
      <h4 className="text-md font-medium text-gray-700 flex items-center gap-2">
        <Wrench className="h-5 w-5" />
        Fabrication Options
      </h4>
      
      {project.fabricationOptions.buckleArrestor && <BuckleArrestorSection />}
      {project.fabricationOptions.pipeInPipe && <PipeInPipeSection />}
      {project.fabricationOptions.bulkhead && <BulkHeadSection />}
    </div>
  );
}; 